import { styled } from "@mui/material/styles";
import { useStoreState, useStoreActions } from "easy-peasy";
import {
  LightMode as LightModeIcon,
  DarkMode as DarkModeIcon
} from "@mui/icons-material";

/**
 * Fixed bottom-left pill that toggles the persisted light/dark theme. Mirrors
 * the refresh button's look. Rendered on both the dashboard and the login page.
 */
export default function ThemeToggle() {
  const themeMode = useStoreState(state => state.settings.themeMode);
  const setThemeMode = useStoreActions(actions => actions.settings.setThemeMode);

  const handleToggle = () => {
    setThemeMode(themeMode === "dark" ? "light" : "dark");
  };

  return (
    <StyledThemeToggle
      onClick={handleToggle}
      aria-label="Toggle light/dark mode"
    >
      {themeMode === "light" ? (
        <StyledToggleIcon as={LightModeIcon} />
      ) : (
        <StyledToggleIcon as={DarkModeIcon} />
      )}
    </StyledThemeToggle>
  );
}

const StyledThemeToggle = styled("div")({
  background: "var(--teleforce-750)",
  borderRadius: 50,
  padding: "1rem",
  display: "inline-flex",
  position: "fixed",
  bottom: "1rem",
  left: "2rem",
  cursor: "pointer",
  zIndex: 1000
});

const StyledToggleIcon = styled(LightModeIcon)({
  fontSize: 25,
  color: "var(--teleforce-50)",
  cursor: "pointer"
});
